export * from "./app-whats-new.component";



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/app-whats-new/index.ts